module.exports = __webpack_public_path__ + "entry-150bfe9b/Background_04_1x1_a-41e64f6eb10f6ef4b5511f32286196ce.svg";